import { IsoGrid, IsoIllustration } from "./Iso";
import { LocaleLink } from "./LocaleLink";

export function NotFoundBlock({
  title,
  lead,
  backTo,
  backLabel,
}: {
  title: string;
  lead: string;
  backTo: string;
  backLabel: string;
}) {
  return (
    <div className="relative isolate">
      <IsoGrid intensity="medium" />
      <div className="container-page flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
        <IsoIllustration
          name="error404"
          alt="Isometric 404 illustration"
          className="w-full max-w-sm"
          parallax={false}
        />
        <h1 className="mt-8 font-display text-3xl font-bold md:text-4xl">{title}</h1>
        <p className="mt-4 max-w-md text-muted-foreground">{lead}</p>
        <LocaleLink
          to={backTo}
          className="mt-8 inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
        >
          {backLabel}
        </LocaleLink>
      </div>
    </div>
  );
}
